import { render } from "./ConciergeDashboard.vue?vue&type=template&id=465b8ec0"
import script from "./ConciergeDashboard.vue?vue&type=script&lang=js"
export * from "./ConciergeDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__